import React, { Fragment, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { insertDocument } from "../database/insert";
import { Spinner } from "react-bootstrap";


const InsertDataButtonModal = (props) => {

  const label = props.label;
  const dbName = props.dbName;
  const elementObjectKey = props.elementObjectKey;
  const elementDescriptionObjectKey = `${props.elementObjectKey}Description`;
  const [element, setElement] = useState('');
  const [elementDescription, setElementDescription] = useState('');
  const onSuccessConfirmation = props.onSuccessConfirmation;

  const [show, setShow] = useState(false);
  const [loaderState, setLoaderState] = useState(false);
  const displayName = props.displayName;

  function handleClose() {
    setElement("");
    setElementDescription("");
    setShow(false);
  }
  const handleShow = () => setShow(true);

  function elementListener(event) {
    setElement(event.target.value.toUpperCase());
  }
  function elementDescriptionListener(event) {
    setElementDescription(event.target.value);
  }

  async function createNewElement() {
    if (!validateInputs()) {
      alert(`${label} is required`);
      return;
    }
    const elementData = {
      [elementObjectKey]: element,
      [elementDescriptionObjectKey]: elementDescription
    };
    const uniqueKeyFilter = [
      { key: elementObjectKey, inputValue: element}
    ];
    setLoaderState(true);
    const insertSuccess = await insertDocument(
      dbName,
      elementData,
      elementObjectKey,
      false,
      uniqueKeyFilter,
      true,
      displayName
    );
    if (!insertSuccess){
      return;
    }
    setLoaderState(false);
    setElement(element);
    onSuccessConfirmation(true);
    handleClose();
  }

  function validateInputs() {
    if (!element) {
      return false;
    }
    return true;
  }


  return (
    <React.Fragment>
      <Button
        variant="warning"
        onClick={handleShow}
      >
        Create New {label}
      </Button>
      <Modal
        size="m"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{
            backgroundColor: "#064422",
            color:"#fff"
          }}
        >
          <Modal.Title>Create New {label}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#c5f4e6"
          }}
        >
          <Form>
          <Form.Group className="mb-3" controlId="inputItem">
            <InputGroup className="mb-1" size="sm">
            <InputGroup.Text id="element">{label}</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder={label}
              value={element}
              onChange={elementListener}
            />
            </InputGroup>
            <InputGroup className="mb-1" size="sm">
            <InputGroup.Text id="itemTypeDescription">{label} Description</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder={label.concat(" Description")}
              value={elementDescription}
              onChange={elementDescriptionListener}
            />
            </InputGroup>
          </Form.Group>
          </Form>
          <center>
          { loaderState
            ? <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            : <Fragment>
              <Button
                variant="secondary"
                onClick={handleClose}
              >
                Cancel
              </Button>
              &nbsp;
              <Button
                variant="warning"
                onClick={createNewElement}
              >
                Create
              </Button>
              </Fragment>
          }
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            backgroundColor: "#c5f4e6"
          }}
        >
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default InsertDataButtonModal

